module.exports = __webpack_public_path__ + "Server-Healthy.AzureServiceFabricCluster.9e11e8a55bbaa7eadf45eb3bac1bd6e3.hashedasset.svg";